import { EmployeeApi } from 'axiosApi/apis/employee-api';
import { setApiKeyToObject } from 'axiosApi/common';
import { AxiosResponse } from 'axios';

export class UserProfileApiWrapper {
  private readonly employeeApi: EmployeeApi;

  constructor(employeeApi: EmployeeApi) {
    this.employeeApi = employeeApi;
  }

  private async buildHeaders(): Promise<Record<string, string>> {
    const configuration = (this.employeeApi as any).configuration;
    const headers: Record<string, string> = {};
    await setApiKeyToObject(headers, 'Userentity', configuration);
    await setApiKeyToObject(headers, 'Referer', configuration);
    await setApiKeyToObject(headers, 'Authorization', configuration);
    return headers;
  }

  private get axios() { return (this.employeeApi as any).axios; }
  private get basePath(): string { return (this.employeeApi as any).basePath; }

  async getMyProfile(version = '1'): Promise<AxiosResponse<any>> {
    const headers = await this.buildHeaders();
    return this.axios.get(`${this.basePath}/api/v${version}/UserProfile/me`, { headers });
  }

  async upsertMyProfile(version = '1', data: {
    firstName?: string;
    lastName?: string;
    initials?: string;
    title?: string;
  }): Promise<AxiosResponse<any>> {
    const headers = await this.buildHeaders();
    headers['Content-Type'] = 'application/json';
    return this.axios.put(`${this.basePath}/api/v${version}/UserProfile/me`, data, { headers });
  }

  async uploadSignature(version = '1', file: File): Promise<AxiosResponse<any>> {
    const headers = await this.buildHeaders();
    const formData = new FormData();
    formData.append('image', file);
    return this.axios.post(`${this.basePath}/api/v${version}/UserProfile/me/signature`, formData, { headers });
  }

  async uploadInitialsImage(version = '1', file: File): Promise<AxiosResponse<any>> {
    const headers = await this.buildHeaders();
    const formData = new FormData();
    formData.append('image', file);
    return this.axios.post(`${this.basePath}/api/v${version}/UserProfile/me/initials-image`, formData, { headers });
  }

  async getSignatureUrl(version = '1'): Promise<AxiosResponse<any>> {
    const headers = await this.buildHeaders();
    return this.axios.get(`${this.basePath}/api/v${version}/UserProfile/me/signature-url`, { headers });
  }

  async getInitialsUrl(version = '1'): Promise<AxiosResponse<any>> {
    const headers = await this.buildHeaders();
    return this.axios.get(`${this.basePath}/api/v${version}/UserProfile/me/initials-url`, { headers });
  }
}
